<!-- Button with mat-button -->
@if (buttonType === 'button') {
  <button
    mat-button
    [type]="type"
    class="custom-button"
    [class.delete-button]="isDelete"
    [class.inverted-button]="isInverted"
    (click)="onClick()"
    [disabled]="isDisabled"
    >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
}

<!-- Button with mat-stroked-button -->
@if (buttonType === 'stroked-button') {
  <button
    mat-stroked-button
    [type]="type"
    class="custom-button"
    [class.delete-button]="isDelete"
    (click)="onClick()"
    [disabled]="isDisabled"
    >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
}

<!-- Button content -->
<ng-template #buttonContent>
  @if (!isIcon && icon) {
    <span class="material-symbols-outlined menu-icon">
      {{ icon }}
    </span>
  }
  @if (isIcon && icon) {
    <mat-icon>{{ icon }}</mat-icon>
  }
  {{ label }}
</ng-template>
